<template>
<div class="main-view-padding has-header">
    <div class="header main" v-header-position-lock>
        <div class="align-left">
            <dateselectionheader :label="dateDisplay" @PrevDate="modDate('sub')" @NextDate="modDate('add')" />
        </div>
        <div class="align-middle">
            <headerbuttonstack :state="headerButtons" />
        </div>
        <div class="align-right">
            <buttonc v-if="storeData != null" type="square" icon="fa-info" v-tooltip="$t('export.comp.showSelectedSoftware')" @click="showChosenSoftwarePopup"/>
        </div>
    </div>
    <!--
    <div class="header main">
      <dateselectionheader :label="date.format('MMMM')"></dateselectionheader>
    </div>
      <div class="employee" v-for="employee in employees" :key="employee.id">
        <employeeentry :state="employee" />
      </div>

      -->



    <div v-if="selectedStore != null" class="scrollbar-container">
        <div class="full split-bottom">
            <div class="header">
                <div class="label">{{ $t('global.view.selectCompany') }}</div>
            </div>
            <div style="float: left !important; margin: 4px 0px 4px -5px;">
                <buttonc :disabled="loading" v-for="store in storeArray" v-bind:key="store.id" :label="store.name" :active="selectedStore != null && selectedStore == store.id" @click="selectedStore = store.id"/>
            </div>

        </div>
        <br /><br />
        <div v-if="loading" class="loading-md bg">
            <i class="fas fa-spinner"></i>
            <br/>
            <div v-if="!$helpers.isEmpty(loadingText)" class="loading-text">
                {{ loadingText }}
            </div>
        </div>
        <div v-else>
          <div class="full" style="margin-top: -16px; margin-bottom: 16px;">
            <div class="header">
              <div v-if="storeData != null && softwareId == 0" class="label">
                  {{ $t('global.view.useDailyExportInstead') }}
              </div>
            </div>
          </div>


          <div v-if="storeData != null && softwareId == 1">

            <table class="table table-striped table-borderless">
                <tr>
                    <th class="documentsTh" scope="col">ID</th>
                    <th class="documentsTh" scope="col" v-if="softwareId == 0">
                        {{ $t('global.view.storeBmdId') }}
                    </th>
                    <th class="documentsTh" scope="col" v-if="softwareId == 1">
                        {{ $t('global.view.costCenterId') }}
                    </th>
                    <th class="documentsTh" style="width: 200px;" scope="col" v-if="softwareId == 0">
                        {{ $t('global.view.employeeBmdId') }}
                    </th>
                    <th class="documentsTh" style="width: 200px;" scope="col" v-if="softwareId == 1">
                        {{ $t('global.view.employeeDpwId') }}
                    </th>
                    <th class="documentsTh" scope="col">{{ $t('settings.groups.name') }}</th>
                    <th class="documentsTh" scope="col">{{ $t('global.view.svNumber') }}</th>
                    <th class="documentsTh" scope="col">{{ $t('global.view.type') }}</th>
                    <th class="documentsTh" scope="col" v-if="softwareId == 0">
                        {{ $t('global.view.typeBmdNumber') }}
                    </th>
                    <th class="documentsTh" scope="col">{{ $t('global.view.from') }}</th>
                    <th class="documentsTh" scope="col">{{ $t('global.view.to') }}</th>
                    <th class="documentsTh" scope="col">{{ $t('global.view.days') }}</th>
                </tr>
                <tbody>
                    <tr v-for="absence in exportableTableAbsences" v-bind:key="absence.id">
                        <td class="documentsTd" scope="col">{{ absence.id }}</td>
                        <td class="documentsTd" scope="col" v-if="softwareId == 0">
                            <div v-if="absence.storeExternalId == null">{{ $t('global.view.bmdIdMissing') }}<div class="fas fa-exclamation-circle" style="margin: 1px 0px 0px 4px; display:inline;"></div>
                            </div>
                            <div v-if="absence.storeExternalId != null">{{ absence.storeExternalId }}</div>
                        </td>
                        <td class="documentsTd" scope="col" v-if="softwareId == 1">
                            <div v-if="absence.storeExternalId == null">{{ $t('global.view.dpwIdMissing') }}<div class="fas fa-exclamation-circle" style="margin: 1px 0px 0px 4px; display:inline;"></div>
                            </div>
                            <div v-if="absence.storeExternalId != null">{{ absence.storeExternalId }}</div>
                        </td>

                        <td class="documentsTd" scope="col" v-if="softwareId == 0">
                            <div v-if="!absence.editing">
                                <div v-if="absence.bmdId == null">
                                    <div class="button small right mright8" v-on:click="toggleEmployeeBmd(absence)">
                                        <div class="label">{{ $t('global.view.enterBmdId') }}</div>
                                    </div>
                                </div>
                                <div v-if="absence.bmdId != null">{{ absence.bmdId }}
                                    <div class="button small right mright8" v-on:click="toggleEmployeeBmd(absence)">
                                        <div class="label">{{ $t('global.view.editBmdId') }}</div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="absence.editing">
                                <input style="width: 50%;" v-model="absence.bmdId" />
                                <div class="button small right mright8" v-on:click="saveEmployeeBmd(absence)">
                                    <div class="label">{{ $t('employee.data.save') }}</div>
                                </div>
                            </div>
                        </td>
                        <td class="documentsTd" scope="col" v-if="softwareId == 1">
                            <div v-if="!absence.editing">
                                <div v-if="absence.dpwId != null">{{ absence.dpwId }}
                                </div>
                            </div>
                        </td>

                        <td class="documentsTd" scope="col">{{ absence.lastName }} {{ absence.firstName }}</td>
                        <td class="documentsTd" scope="col">{{ absence.socialsecurity }}</td>
                        <td class="documentsTd" scope="col">{{ typeMap[absence.absence.mdType] }}</td>
                        <td class="documentsTd" scope="col" v-if="softwareId == 0">{{ typeMapBmd[absence.absence.mdType] }}</td>
                        <td class="documentsTd" scope="col">{{ absence.absence.fromMoment.format('DD.MM.') }}</td>
                        <td class="documentsTd" scope="col">{{ absence.absence.toMoment.format('DD.MM.') }}</td>
                        <td class="documentsTd" scope="col">{{ absence.absence.totalDays }}</td>
                    </tr>
                </tbody>
            </table>

            <hr />
            <br />
            <strong>{{ $t('global.view.valuesNotExported') }}</strong>
            <br />
            <br />

            <table class="table table-striped table-borderless">
                <tr>
                    <th class="documentsTh" scope="col">ID</th>
                    <th class="documentsTh" scope="col" v-if="softwareId == 0">
                        {{ $t('global.view.storeBmdId') }}
                    </th>
                    <th class="documentsTh" scope="col" v-if="softwareId == 1">
                        {{ $t('global.view.costCenterId') }}
                    </th>
                    <th class="documentsTh" scope="col" v-if="softwareId == 0">
                        {{ $t('global.view.employeeBmdId') }}
                    </th>
                    <th class="documentsTh" scope="col" v-if="softwareId == 1">
                        {{ $t('global.view.employeeDpwId') }}
                    </th>
                    <th class="documentsTh" scope="col">{{ $t('settings.groups.name') }}</th>
                    <th class="documentsTh" scope="col">{{ $t('global.view.svNumber') }}</th>
                    <th class="documentsTh" scope="col">{{ $t('global.view.type') }}</th>
                    <th class="documentsTh" scope="col">{{ $t('global.view.from') }}</th>
                    <th class="documentsTh" scope="col">{{ $t('global.view.to') }}</th>
                    <th class="documentsTh" scope="col">{{ $t('global.view.days') }}</th>
                    <th class="documentsTh" scope="col">{{ $t('settings.sync.status') }}</th>
                </tr>
                <tbody>
                    <tr v-for="absence in hiddenTableAbsences" v-bind:key="absence.id">
                        <td class="documentsTd" scope="col">{{ absence.id }}</td>
                        <td class="documentsTd" scope="col" v-if="softwareId == 0">
                            <div v-if="absence.storeExternalId == null">{{ $t('global.view.bmdIdMissing') }}<div class="fas fa-exclamation-circle" style="margin: 1px 0px 0px 4px; display:inline;"></div>
                            </div>
                            <div v-if="absence.storeExternalId != null">{{ absence.storeExternalId }}</div>
                        </td>
                        <td class="documentsTd" scope="col" v-if="softwareId == 1">
                            <div v-if="absence.storeExternalId == null">{{ $t('global.view.dpwIdMissing') }}<div class="fas fa-exclamation-circle" style="margin: 1px 0px 0px 4px; display:inline;"></div>
                            </div>
                            <div v-if="absence.storeExternalId != null">{{ absence.storeExternalId }}</div>
                        </td>

                        <td class="documentsTd" scope="col" v-if="softwareId == 0">
                            <div v-if="absence.bmdId == null">{{ $t('global.view.bmdIdMissing') }}</div>
                            <div v-if="absence.bmdId != null">{{ absence.bmdId }}</div>
                        </td>
                        <td class="documentsTd" scope="col" v-if="softwareId == 1">
                            <div v-if="absence.dpwId == null">{{ $t('global.view.dpwIdMissing') }}</div>
                            <div v-if="absence.dpwId != null">{{ absence.dpwId }}</div>
                        </td>

                        <td class="documentsTd" scope="col">{{ absence.lastName }} {{ absence.firstName }}</td>
                        <td class="documentsTd" scope="col">{{ absence.socialsecurity }}</td>
                        <td class="documentsTd" scope="col">{{ typeMap[absence.absence.mdType] }}</td>
                        <td class="documentsTd" scope="col"></td>
                        <td class="documentsTd" scope="col"></td>
                        <td class="documentsTd" scope="col">{{ absence.absence.totalDays }}</td>
                        <td class="documentsTd" scope="col">
                            <span v-if="absence.absence.mdApproved"></span>
                            <span v-if="!absence.absence.mdApproved">{{ $t('global.view.notApproved') }}</span>
                            <span v-if="absence.absence.softDelete">{{ $t('global.view.deleted') }}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        </div>
    </div>

</div>
</template>

<script>
// @ is an alias to /src
import {
    mapState,
    mapGetters
} from 'vuex';
export default {
    name: 'AbsenceExport',
    components: {},
    data() {
        return {
            selectedStore: null,
            stores: [],




            loading: true,
            loadingText: this.$t('employee.comp.dataLoading') + '...',
            selectedDate: this.$helpers.getMomentTZ().clone(),

            companyData: null,
            storeData: null,
            isBalanceConfirmationRequired: true,
            storeExternalId: '',

            timeframeStart: this.$helpers.getMomentTZ().clone().startOf('month'),
            timeframeEnd: this.$helpers.getMomentTZ().clone().endOf('month'),

            absenceExports: [],
            absences: [],

            absenceEmployeeMap: {},

            exportableTableAbsences: [],
            hiddenTableAbsences: [],
            softwareId: 0,

            stateMap: {
                1: this.$t('comp.view.notAvailable'),
                2: this.$t('comp.view.onlyAvailable'),
                3: this.$t('comp.view.desired'),
                4: this.$t('global.view.aversion')
            },
            typeMap: {
                1: this.$t('comp.view.vacation'),
                2: this.$t('comp.view.sickLeave'),
                3: this.$t('global.view.publicHolidayComp'),
                4: this.$t('global.view.notAvailableOther'),
                5: this.$t('comp.view.noContract'),
                6: this.$t('global.view.careLeave'),
                7: this.$t('comp.view.education'),
                8: this.$t('global.view.wageContinuation')
            },
            typeMapBmd: {
                1: '1',
                2: '2',
                6: '5'
            },

            monthNames: {
                0: this.$t('global.time.month0'),
                1: this.$t('global.time.month1'),
                2: this.$t('global.time.month2'),
                3: this.$t('global.time.month3'),
                4: this.$t('global.time.month4'),
                5: this.$t('global.time.month5'),
                6: this.$t('global.time.month6'),
                7: this.$t('global.time.month7'),
                8: this.$t('global.time.month8'),
                9: this.$t('global.time.month9'),
                10: this.$t('global.time.month10'),
                11: this.$t('global.time.month11'),
            },

        }
    },
    mounted() {
        let view = this;
        view.loading = true;
        this.refresh(true);
    },
    watch: {
        companyId: function (val, oldVal) {
            this.selectedStore = null;
            this.stores = [];
            this.refresh(true);
        },
        selectedStore: function (val, oldVal) {
            if(val != null)
            this.refresh(true);
        },
    },
    computed: {
        ...mapGetters(['companyId', 'isSuperUser', 'externalServicesMap', 'storeSettings', 'employeeMap', 'storeArray', 'selectedStores', 'externalSoftwaresMap']),
        dateDisplay: function () {
            let view = this;
            if (view.storeData != null) {
                if (view.softwareId == 0) {
                    return view.monthNames[view.timeframeStart.months()] + " " + view.timeframeStart.format('YYYY');
                } else if (view.softwareId == 1) {
                    return view.timeframeStart.format("DD") + '. - ' + view.timeframeEnd.format("DD") + '. ' + view.monthNames[view.timeframeStart.months()] + " " + view.timeframeStart.format('YYYY');
                }
            }
            return "-";
        },
        headerButtons() {
            let view = this;

            let state = {
                buttons: []
            };
            state.buttons.push({
                type: "block",
                icon: "fa-refresh",
                click: () => {
                    view.refresh();
                },
                tooltip: 'Refresh'
            });
            if (view.storeData != null && (view.softwareId == 0)) {
                state.buttons.push({
                    type: "block",
                    icon: "fa-file-download",
                    click: () => {
                        view.export();
                    },
                    tooltip: this.$t('global.view.downloadFile')
                });
            }
            if (view.storeData != null && view.softwareId == 1) {
                state.buttons.push({
                    type: "block",
                    icon: "fa-server",
                    click: () => {
                        view.saveOnSFTP();
                    },
                    tooltip: this.$t('global.view.saveFileOnServer')
                });
            }
            return state;
        },
    },
    methods: {
        reset: function () {
            let view = this;
            view.companyData = null;
            view.absences = [];
            view.exportableTableAbsences = [];
            view.hiddenTableAbsences = [];
        },

        showChosenSoftwarePopup($event){
            let info = this.$t('global.view.storeProcessesDataFor') + ' ' +
                ((this.storeData != null && this.externalSoftwaresMap && this.externalSoftwaresMap[this.softwareId]) ?
                    this.externalSoftwaresMap[this.softwareId].name : this.$t('global.view.notSelected'));
            let dataEntries = [];
            dataEntries.push({key: 'info', hidden: false, type: 'output', value: info});
            this.$helpers.OpenPopup({
                elRelative: $event.currentTarget,
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    selectCallback: function (){
                        console.log('Bye bye...');
                    },
                    positiveButtonLabel: this.$t('global.ui.close')
                },
                header: this.$t('global.view.selectedSoftware'),
                remainAfterSelect: false,
                expanded: true,
                locked: false
            });
        },

        refresh: function (changeTimeframe = false, force = false) {
            let view = this;
            view.reset();


            view.$helpers.GetExternalSoftwaresMap();
            view.$helpers.GetCompanySettings(force).then(response => {
                view.$helpers.success(
                    this.$t('global.view.companySettings'),
                    this.$t('global.view.companySettingsLoaded')
                );
                view.updateCompanySettings(response);
                view.$helpers.GetStoresArray().then((stores) => {
                    view.$helpers.success(this.$t('report.comp.locations'), this.$t('global.view.locationsLoaded'));
                    view.storesData = stores;
                    console.log(stores);
                    if(view.selectedStore == null){
                        if(stores.length > 0){
                            view.selectedStore = stores[0].id;
                            console.log('Auto selected first store:');
                            console.log(view.selectedStore);
                            view.$forceUpdate();
                        }
                    }
                    view.loading = true;
                    if (view.storesData.length > 0) {
                        view.storesData = view.storeArray;
                        let selectedStoreIndex = 0;
                        for (let i = 0; i < view.storesData.length; i++) {
                            if(view.storesData[i].id == view.selectedStore){
                                selectedStoreIndex = i;
                            }
                        }

                        view.storeData = view.storesData[selectedStoreIndex];
                        //view.isBalanceConfirmationRequired = (view.storeData == null || view.storeData.isBalanceConfirmationRequired == null || view.storeData.isBalanceConfirmationRequired == undefined || view.storeData.isBalanceConfirmationRequired);
                        if(view.companyData != null){
                            if(view.companyData.individualStoreIds == 1){
                                if (view.storeData != null) {
                                    if (view.softwareId == 0) {
                                        view.storeExternalId = view.storeData.bmdId;
                                    } else if (view.softwareId == 1) {
                                        view.storeExternalId = view.storeData.dpwId;
                                    }
                                }
                            }else{
                                if (view.softwareId == 0) {
                                    view.storeExternalId = view.companyData.bmdId;
                                } else if (view.softwareId == 1) {
                                    view.storeExternalId = view.companyData.dpwId;
                                }
                            }
                                if (changeTimeframe) {
                                    if (view.companyData != null && view.softwareId == 0) {
                                        //BMD PFAD MONATLICH
                                        view.selectedDate.subtract(1, 'months');
                                        view.timeframeStart = view.selectedDate.clone().startOf('month');
                                        view.timeframeEnd = view.selectedDate.clone().endOf('month');
                                        view.$forceUpdate();
                                    } else if (view.companyData != null && view.softwareId == 1) {
                                        //DPW PFAD ZWEI WÖCHENTLICH
                                        if (view.selectedDate.date() > 16) {
                                            view.timeframeStart = view.selectedDate.clone().startOf('month');
                                            view.timeframeEnd = view.timeframeStart.clone().add('days', 14);
                                            view.$forceUpdate();
                                        } else {
                                        this.selectedDate.startOf('month');
                                        view.timeframeStart = view.selectedDate.clone().subtract(1, 'months').startOf('month').add('days',15);
                                        view.timeframeEnd = view.timeframeStart.clone().endOf('month');
                                        view.$forceUpdate();
                                        }
                                    }
                                }
                        }

                        view.createAbsenceExport();
                    }
                })
            }).catch(error => {
                console.log("REFRESH ERROR: "+error)
            });
        },
        updateCompanySettings: function(response){
            let view = this;
            if(response.data.length == 1){
                view.companyData = response.data[0];
                view.softwareId = view.companyData.softwareId;
            }
        },

        loadEmployees: function () {
            let view = this;
            view.$helpers.GetEmployeeMapOLD(true,false,view.selectedStore)
                .then(response => {
                    view.$helpers.success(view.$t('global.ui.employee'), view.$t('global.view.employeesLoaded'));
                    let map = {};

                    Object.values(view.employeeMap).forEach(e => {
                        map[e.id] = {
                            mdId: e.mdId,
                            absences: []
                        };
                    });
                    view.absenceEmployeeMap = map;

                    view.loadAbsences();

                }).catch(function (error) {
                    console.log(error.response);
                });
        },

        /*
              loadWorktimeBalance: function(){
                let view = this;
                let url = '/api/workbalance';

                url = this.$helpers.appendParam("store_id", this.$store.state.storeId, url, '/api/workbalance');
                //url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/workbalance');

                this.axios({
                  method: 'get',
                  headers: {
                    'AUTHORIZATION': "Bearer "+this.$store.state.jwt
                  },
                  url: url,
                }).then(response => {
                }).catch(function (error) {
                  view.saves = false;
                })
              },*/
        loadAbsences: function () {
            console.log("LOAD ABSENCES");
            let view = this;
            let url = '/api/absence';

            url = this.$helpers.appendParam("storeId", view.selectedStore, url, '/api/absence');
            //url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/workbalance');
            url = this.$helpers.appendParam("from", view.timeframeStart.format('DD.MM.YYYY'), url, '/api/absence');
            url = this.$helpers.appendParam("to", view.timeframeEnd.format('DD.MM.YYYY'), url, '/api/absence');

            this.axios({
                method: 'get',
                headers: {
                    'AUTHORIZATION': "Bearer " + this.$store.state.jwt
                },
                url: url,
            }).then(response => {
                view.$helpers.success(view.$t('global.ui.employee'), view.$t('global.view.employeesLoaded'));
                view.absences = response.data.data;


                Object.values(view.absences).forEach(absence => {


                    let fromMoment = view.$helpers.getMomentFromStringUTC(absence.from, 'YYYY-MM-DD HH:mm:ss').tz("Europe/Vienna");
                    let toMoment = view.$helpers.getMomentFromStringUTC(absence.to, 'YYYY-MM-DD HH:mm:ss').tz("Europe/Vienna");

                    if(view.softwareId == 1 && fromMoment.clone().startOf('day').format('x') == toMoment.clone().startOf('day').format('x')){
                        if (fromMoment >= view.timeframeStart && toMoment <= view.timeframeEnd) {

                            absence.fromTimestamp = fromMoment.clone().format('x');
                            absence.fromMoment = fromMoment.clone();
                            absence.toMoment = toMoment.clone();
                            absence.totalDays = Math.round(toMoment.diff(fromMoment, 'minutes') / (24*60) * 100) / 100;
                            view.absenceEmployeeMap[absence.employeeId].absences.push(absence);



                        if(view.absenceEmployeeMap[absence.employeeId]){
                        //view.actualShiftEmployeeMap[actualShift.employeeId].actualShifts.push(actualShift);
                            view.absenceEmployeeMap[absence.employeeId].absences.push(absence);
                        }else{
                            view.$helpers.success(
                                view.$t('global.ui.employee'),
                                view.$t('global.view.employeesLoaded')
                            );
                        console.log("Employee with the ID: " + absence.employeeId + " is missing in shift: " + absence.id);
                        }
/*
                        if(typeof view.absenceEmployeeMap[absence.employeeId] === 'undefined'){
                            console.log("employee not found - Maybe run the sync command");
                        }else{
                            view.absenceEmployeeMap[absence.employeeId].absences.push(absence);
                        }*/
                        }
                    }else{
                        if (fromMoment < view.timeframeStart) {
                            fromMoment = view.timeframeStart.clone();
                        }

                        let midnightStart = fromMoment.clone().startOf('day');
                        if (midnightStart.format('x') != fromMoment.format('x')) {
                            fromMoment = fromMoment.clone().add(1, 'days').startOf('day');
                        }

                        let midnightEnd = toMoment.clone().startOf('day');
                        if (midnightEnd.format('x') != toMoment.format('x')) {
                            toMoment = toMoment.clone().startOf('day');
                        }
                        toMoment.subtract(1, 'days');
                        if (toMoment > view.timeframeEnd) {
                            toMoment = view.timeframeEnd.clone().startOf('day');
                        }

                        absence.fromTimestamp = fromMoment.clone().format('x');
                        absence.fromMoment = fromMoment.clone();
                        absence.toMoment = toMoment.clone();
                        absence.totalDays = toMoment.diff(fromMoment, 'days') + 1;
/*
                        if(typeof view.absenceEmployeeMap[absence.employeeId] === 'undefined'){
                            console.log("employee not found - Maybe run the sync command");
                        }else{
                            view.absenceEmployeeMap[absence.employeeId].absences.push(absence);
                        }*/
                        if(view.absenceEmployeeMap[absence.employeeId]){
                        //view.actualShiftEmployeeMap[actualShift.employeeId].actualShifts.push(actualShift);
                            view.absenceEmployeeMap[absence.employeeId].absences.push(absence);
                        }else{
                            view.$helpers.error(
                                view.$t('global.view.error'),
                                view.$t('global.view.absenceAssignFailed')
                            );
                        console.log("Employee with the ID: " + absence.employeeId + " is missing in shift: " + absence.id);
                        }

                    }

                });

                console.log("REFRESH VISIBLE MAPS");
                view.refreshVisibleMaps();

            }).catch(function (error) {
                view.saves = false;
            })
        },

        refreshVisibleMaps: function () {
            console.log("refreshVisibleMaps");
            let view = this;

            Object.values(view.absences).forEach(absence => {
                let add = false;
                let addHidden = false;
                if (absence.mdState == 1) { // Only absences (other values than 1 are whishes,and other stuff)
                    addHidden = true;

                    if(!absence.softDelete){
                        if (view.softwareId == 0) {
                            if (absence.mdType == 1 || absence.mdType == 2 || absence.mdType == 6) {
                                if (!absence.mdDeleted && absence.mdApproved) {
                                    if (absence.totalDays > 0) {
                                        add = true;
                                    }
                                }
                            }
                        } else if (view.softwareId == 1) {
                            if (absence.mdType == 1 || absence.mdType == 2 || absence.mdType == 3 || absence.mdType == 6 || absence.mdType == 7 || absence.mdType == 8) {
                                if (!absence.mdDeleted && absence.mdApproved) {
                                    if (absence.totalDays > 0) {
                                        add = true;
                                    }
                                }
                            }
                        }
                    }

                }

                if (add) {
                    view.exportableTableAbsences.push({
                        id: absence.id,
                        editing: false,
                        storeExternalId: view.storeExternalId,
                        bmdId: view.employeeMap[absence.employeeId].bmdId,
                        dpwId: view.employeeMap[absence.employeeId].dpwId,
                        socialsecurity: view.employeeMap[absence.employeeId].socialsecurity,
                        firstName: view.employeeMap[absence.employeeId].firstName,
                        lastName: view.employeeMap[absence.employeeId].lastName,
                        employeeId: absence.employeeId,
                        absence: absence
                    });
                } else if (addHidden) {
                    view.hiddenTableAbsences.push({
                        id: absence.id,
                        editing: false,
                        storeExternalId: view.storeExternalId,
                        bmdId: view.employeeMap[absence.employeeId].bmdId,
                        dpwId: view.employeeMap[absence.employeeId].dpwId,
                        socialsecurity: view.employeeMap[absence.employeeId].socialsecurity,
                        firstName: view.employeeMap[absence.employeeId].firstName,
                        lastName: view.employeeMap[absence.employeeId].lastName,
                        employeeId: absence.employeeId,
                        absence: absence
                    });

                }
            });

            view.exportableTableAbsences.sort(view.sortAbsenceArray);
            view.hiddenTableAbsences.sort(view.sortAbsenceArray);
            view.loading = false;
        },

        sortAbsenceArray: function (a, b) {
            let x = a.lastName + " " + a.firstName;
            let y = b.lastName + " " + b.firstName;
            if (x.toUpperCase() < y.toUpperCase()) return -1;
            if (x.toUpperCase() > y.toUpperCase()) return 1;

            if (a.absence.fromTimestamp < b.absence.fromTimestamp) return -1;
            if (a.absence.fromTimestamp > b.absence.fromTimestamp) return 1;
            return 0;
        },

        createAbsenceExport: function () {
            //If the export for the timeframe is not existing it gets created and returned immediately
            //Otherwise if it already exists, it just gets returned with no side effects
            let view = this;
            let url = '/api/absenceexport';

            let payload = {
                storeId: view.selectedStore,
                from: view.timeframeStart.format('DD.MM.YYYY'),
                to: view.timeframeEnd.format('DD.MM.YYYY'),
            };

            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "Bearer " + this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                view.$helpers.success(
                    view.$t('global.view.absences'),
                    view.$t('global.view.absenceStructureCreated')
                );
                view.absenceExports = response.data.data;
                view.loadEmployees();
            }).catch(function (error) {
                console.log(error);
            })
        },

        modDate: function(method){
          let view = this;
          if(view.storeData != null && view.softwareId == 0){
            //BMD PFAD MONATLICH
            if(method == 'add'){
              this.selectedDate.add(1, 'months');
              this.timeframeStart = this.selectedDate.clone().startOf('month');
              this.timeframeEnd = this.selectedDate.clone().endOf('month');
              this.$forceUpdate();
            }else if(method == 'sub'){
              this.selectedDate.subtract(1, 'months');
              this.timeframeStart = this.selectedDate.clone().startOf('month');
              this.timeframeEnd = this.selectedDate.clone().endOf('month');
              this.$forceUpdate();
            }
          }else if(view.storeData != null && view.softwareId == 1){
            //DPW PFAD ZWEI WÖCHENTLICH
            if(method == 'add'){
              if(view.selectedDate.date() > 16){
                this.selectedDate.add(1, 'months').startOf('month');
                view.timeframeStart = view.selectedDate.clone().subtract(1, 'months').startOf('month').add('days',15);
                view.timeframeEnd = view.timeframeStart.clone().endOf('month');
                view.$forceUpdate();
              }else{
                this.selectedDate.endOf('month');
                view.timeframeStart = view.selectedDate.clone().startOf('month');
                view.timeframeEnd = view.timeframeStart.clone().add('days',14);
                view.$forceUpdate();
              }
            }else if(method == 'sub'){
              if(view.selectedDate.date() > 16){
                this.selectedDate.startOf('month');
                view.timeframeStart = view.selectedDate.clone().subtract(1, 'months').startOf('month').add('days',15);
                view.timeframeEnd = view.timeframeStart.clone().endOf('month');
                view.$forceUpdate();
              }else{
                this.selectedDate.subtract(1, 'months').endOf('month');
                view.timeframeStart = view.selectedDate.clone().startOf('month');
                view.timeframeEnd = view.timeframeStart.clone().add('days',14);
                view.$forceUpdate();
              }
            }
          }
          this.refresh();
        },
        toggleEmployeeBmd: function (absence) {
            let view = this;

            Object.values(view.exportableTableAbsences).forEach(absence => {
                absence.editing = false;
            });

            absence.editing = true;
            view.$forceUpdate();
        },
        saveEmployeeBmd: function (absence) {
            let view = this;

            view.saves = true;

            let payload = {
                storeId: view.selectedStore,
                bmdId: absence.bmdId,
                employeeId: absence.employeeId,
            };
            let url = '/api/employee';

            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "Bearer " + this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                view.saves = false;
                view.$helpers.success(view.$t('global.view.saveSuccess'), view.$t('global.view.dataSaved'));

                view.employeeMap[absence.employeeId].bmdId = absence.bmdId;
                Object.values(view.exportableTableAbsences).forEach(absence => {
                    absence.editing = false;
                    absence.bmdId = view.employeeMap[absence.employeeId].bmdId;
                });
                Object.values(view.hiddenTableAbsences).forEach(absence => {
                    absence.editing = false;
                    absence.bmdId = view.employeeMap[absence.employeeId].bmdId;
                });

            }).catch(function (error) {
                view.saves = false;
                view.$helpers.error(view.$t('global.view.saveFailed'), view.$t('global.view.errorSavingData'));
            })

            view.$forceUpdate();
        },
        toggleEmployeeDpw: function (absence) {
            let view = this;
            Object.values(view.exportableTableAbsences).forEach(absence => {
                absence.editing = false;
            });
            absence.editing = true;
            view.$forceUpdate();
        },
        saveEmployeeDpw: function (absence) {
            let view = this;

            if (absence.dpwId.length > 8) {
                view.$helpers.error(view.$t('global.view.saveFailed'), view.$t('global.view.numberMax8Digits'));
                return;
            }

            view.saves = true;

            let payload = {
                storeId: view.selectedStore,
                dpwId: absence.dpwId,
                employeeId: absence.employeeId,
            };
            let url = '/api/employee';

            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "Bearer " + this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                view.saves = false;
                view.$helpers.success(view.$t('global.view.saveSuccess'), view.$t('global.view.dataSaved'));

                view.employeeMap[absence.employeeId].dpwId = absence.dpwId;
                Object.values(view.exportableTableAbsences).forEach(absence => {
                    absence.editing = false;
                    absence.dpwId = view.employeeMap[absence.employeeId].dpwId;
                });
                Object.values(view.hiddenTableAbsences).forEach(absence => {
                    absence.editing = false;
                    absence.dpwId = view.employeeMap[absence.employeeId].dpwId;
                });

            }).catch(function (error) {
                view.saves = false;
                view.$helpers.error(view.$t('global.view.saveFailed'), view.$t('global.view.errorSavingData'));
            })

            view.$forceUpdate();
        },

        export: function () {
            let view = this;
            let canExport = true;
            Object.values(view.exportableTableAbsences).forEach(absence => {
                if (absence.bmdId == null) {
                    canExport = false;
                }
            });
            if (canExport) {
                let view = this;
                let url = '/api/absenceexport/export';

                url = this.$helpers.appendParam("storeId", view.selectedStore, url, '/api/absenceexport/export');
                url = this.$helpers.appendParam("from", view.timeframeStart.format('DD.MM.YYYY'), url, '/api/absenceexport/export');
                url = this.$helpers.appendParam("to", view.timeframeEnd.format('DD.MM.YYYY'), url, '/api/absenceexport/export');

                this.axios({
                    method: 'get',
                    headers: {
                        'AUTHORIZATION': "Bearer " + this.$store.state.jwt
                    },
                    url: url,
                }).then(response => {
                    view.forceFileDownload(response, view.storeData.storeNumber + "_export_abwesenheiten.csv");
                }).catch(function (error) {
                    console.log(error);
                })
            } else {
                view.$helpers.error(view.$t('global.view.exportFailed'), view.$t('global.view.bmdIdMissingEmployee'));
            }
        },

        saveOnSFTP: function () {
            let view = this;
            let canExport = true;
            Object.values(view.exportableTableAbsences).forEach(absence => {
                if (absence.dpwId == null) {
                    canExport = false;
                }
            });
            if (canExport) {
                let view = this;
                let url = '/api/absenceexport/saveOnSFTP';

                url = this.$helpers.appendParam("storeId", view.selectedStore, url, '/api/absenceexport/saveOnSFTP');
                url = this.$helpers.appendParam("from", view.timeframeStart.format('DD.MM.YYYY'), url, '/api/absenceexport/saveOnSFTP');
                url = this.$helpers.appendParam("to", view.timeframeEnd.format('DD.MM.YYYY'), url, '/api/absenceexport/saveOnSFTP');

                this.axios({
                    method: 'get',
                    headers: {
                        'AUTHORIZATION': "Bearer " + this.$store.state.jwt
                    },
                    url: url,
                }).then(response => {
                    view.$helpers.success(view.$t('global.view.exportSuccess'), view.$t('global.view.fileCreatedSaved'));
                }).catch(function (error) {
                    console.log(error);
                })
            } else {
                view.$helpers.error(view.$t('global.view.exportFailed'), view.$t('global.view.dpwIdMissingEmployee'));
            }
        },

        // TODO: use $helpers function
        forceFileDownload(response, title) {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', title)
            document.body.appendChild(link)
            link.click()
        },

    },
}
</script>

<style scoped>
.employee {
    height: 40px;
    width: 150px;
    margin: 5px;

    position: relative;
    box-shadow: 0 0 1px 1px var(--contrast-3);
    padding: 5px;
    float: left;
}

/* th {
    font-family: DistrictProBold;
    font-size: 13px;
    color: white;
    background: var(--ml);
  }

  td {
    font-family: DistrictProBook;
    font-size: 13px;
  } */
</style>
